export default function CtaSection() {
  return (
    <section className="flex flex-col lg:flex-row">
      <div className="flex-1 relative min-h-[350px] lg:min-h-[500px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20product%20photography%20collage%20of%20shoes%20hoodies%20t-shirts%20and%20accessories%20on%20clean%20cream%20beige%20background%2C%20soft%20natural%20diffused%20lighting%2C%20warm%20earthy%20color%20tones%2C%20editorial%20commercial%20style%2C%20organized%20flat%20lay%20composition%2C%20modern%20catalog%20aesthetic%2C%20negative%20space%20for%20text%20overlay&width=900&height=700&seq=cta-left-bg-001&orientation=landscape"
          alt="GTBuy Spreadsheet product collection"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        <div className="absolute top-6 left-6">
          <span className="text-background-50/70 text-xs font-medium uppercase tracking-wider">
            Limited Access
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-[1.1]">
            Get
            <br />
            Your
            <br />
            GTBuy Sheet
          </h2>
        </div>
      </div>

      <div className="flex-1 bg-background-50 flex items-center justify-center py-12 md:py-16 px-6">
        <div className="max-w-md text-center">
          <h3 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6">
            Buy It Now
          </h3>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
            Ready to streamline your sourcing workflow? GTBuy Spreadsheet gives you the automation
            power to scale your operations, reduce manual errors, and stay ahead of the competition.
            One click takes you to the full platform.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Go to KASpreadsheet
            <i className="ri-arrow-right-line"></i>
          </a>
          <p className="mt-6 text-xs text-foreground-400">
            Join thousands of sourcing professionals already optimizing their workflow
          </p>
        </div>
      </div>
    </section>
  );
}